import { createSelector } from 'reselect';
import _ from 'lodash';

import { getMusicState } from './music';
import { getHasTokenLoadedOnce } from './session';

export const getConfigState = createSelector(
  [getMusicState],
  music => _.get(music, 'config'),
);

export const getHasConfigurated = createSelector(
  [getConfigState],
  config => _.get(config, 'ready', false),
);

export const getHasReadyToFetch = createSelector(
  [getHasConfigurated, getHasTokenLoadedOnce],
  (hasConfig, hasToken) => _.every([hasConfig, hasToken]),
);

export const getConfigLoading = createSelector(
  [getConfigState],
  config => _.get(config, 'loading'),
);

export const getConfigError = createSelector(
  [getConfigState],
  config => _.get(config, 'error', false),
);
